import { render, staticRenderFns } from "./widgetChart.vue?vue&type=template&id=98c87cd4&scoped=true&"
import script from "./widgetChart.vue?vue&type=script&lang=js&"
export * from "./widgetChart.vue?vue&type=script&lang=js&"
import style0 from "./widgetChart.vue?vue&type=style&index=0&id=98c87cd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c87cd4",
  null
  
)

export default component.exports